import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#3543BF',
      light: '#C2C7EC',
      dark: '#1F2A8D',
      lighter: '#EFF1FF',
    },
    secondary: {
      main: '#fe7d32',
      contrastText: '#fff',
    },
    backgrounds: {
      dark: '#EFEFEF',
      light: '#F8F8F8',
      white: '#FFFFFF',
      dividerDark: '#EBEBEB',
      divider: '#D2D1D1',
      overlay: '#40404080',
    },
    error: {
      main: '#C62828',
      light: '#E57373',
      lighter: '#FFEBEE',
    },
    success: {
      main: '#37BC8E',
      dark: '#2E7D32',
      light: '#7CE3C0',
      lighter: '#E8FFF0',
    },
    warning: {
      main: '#F2A526',
      light: '#FADCAC',
      lighter: '#FFF8EE',
    },
    action: {
      hoverOpacity: 0.15,
    },
    text: {
      primary: '#404040', // dark
      secondary: '#787878', // light
      link: '#0B61D9',
    },
    graph: {
      accent1: '#0F8EDB',
      accent2: '#EB9071',
      accent3: '#F1CB6A',
      accent4: '#D565BB',
    },
    gray: {
      light: '#BCBCBC',
    },
  },
  breakpoints: {
    keys: ['md', 'lg'],
    values: {
      md: 992,
      lg: 1200,
    },
  },
});

export default theme;
